import { useIntl } from 'react-intl';
import { useCallback } from 'react';
import { Divider, CustomDocument } from '../../../../ui';
import { ContractTerm, ContractTermFile } from '../types';

interface ListingData {
  id: number;
  contract_terms: ContractTerm | null;
}

interface ContractDetailsTabProps {
  listingData: ListingData;
}

export const ContractDetailsTab = ({
  listingData,
}: ContractDetailsTabProps) => {
  const intl = useIntl();

  const handleDownloadContractTemplate = useCallback(
    (fileId: number) => {
      if (listingData?.id) {
        const downloadUrl = `${window.runConfig?.backendUrl}/api/v2/listings/${listingData.id}/contract-terms/download?file_id=${fileId}`;
        window.open(downloadUrl, '_blank');
      }
    },
    [listingData?.id]
  );

  const contractTerms = listingData?.contract_terms;

  if (!contractTerms) {
    return <div>{intl.formatMessage({ id: 'listing.no_contract_terms' })}</div>;
  }

  const filesForDisplay = (contractTerms.files || []).map(
    (file: ContractTermFile) => ({
      uid: file.id.toString(),
      name: file.name || file.original_name,
      status: 'done' as const,
      file_size: file.size_bytes,
      file_format: file.mime_type?.split('/').pop()?.toUpperCase(),
      isExisting: false,
      fileId: file.id,
    })
  );

  return (
    <div>
      {contractTerms.payment_conditions && (
        <>
          <div className="contract-section">
            <h3>{intl.formatMessage({ id: 'listing.payment_conditions' })}</h3>
            <p>{contractTerms.payment_conditions}</p>
          </div>
          <Divider />
        </>
      )}

      {contractTerms.additional_contract_terms && (
        <>
          <div className="contract-section">
            <h3>
              {intl.formatMessage({ id: 'listing.additional_contract_terms' })}
            </h3>
            <p>{contractTerms.additional_contract_terms}</p>
          </div>
          <Divider />
        </>
      )}

      {filesForDisplay.length > 0 && (
        <div className="contract-section">
          <h3>{intl.formatMessage({ id: 'listing.contract_file' })}</h3>
          {filesForDisplay.map((file) => (
            <CustomDocument
              key={file.uid}
              file={file}
              onDownload={() => handleDownloadContractTemplate(file.fileId)}
              showActions={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};
